'use client';
import { motion } from 'motion/react';
import { useI18n } from '@/i18n';

const companies = [
  'DEWA',
  'Etisalat',
  'du',
  'Emirates NBD',
  'ADIB',
  'Logic',
  'Masdar',
  'ADSCC',
];

export function LogoCloud() {
  const { t } = useI18n();

  return (
    <section className="py-16 border-y border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-sm text-muted-foreground text-center mb-8"
        >
          {t.logoCloud.title}
        </motion.p>

        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
          {companies.map((company, i) => (
            <motion.span
              key={company}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="text-lg font-medium text-muted-foreground/40 hover:text-muted-foreground transition-colors"
            >
              {company}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
